import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { lazyGettext } from '@eb/lazy-gettext';
import { Button } from '@eb/eds-button';
import { Icon } from '@eb/eds-icon';
import { LogoApple } from '@eb/eds-iconography';

import { SIZE_BLOCK, STYLE_LINK } from '@eb/eds-button';

import { SOCIAL_EXTERNAL_IDENTITY_PROVIDER_APPLE } from './constants';

import { buildAppleLoginResponse, injectScriptTag } from './utils';

import './AppleLoginButton.scss';

export default class AppleLoginButton extends Component {
    static propTypes = {
        onClick: PropTypes.func.isRequired,
        onSocialConnectVerified: PropTypes.func,
        onSocialConnectNotAuthorized: PropTypes.func,

        clientId: PropTypes.string,
        scope: PropTypes.string,
        redirectURI: PropTypes.string,
        buttonAppleText: PropTypes.string,
        asyncStrategy: PropTypes.string,
    };

    componentDidMount() {
        const { asyncStrategy, skipScriptLoading } = this.props;

        if (!skipScriptLoading) {
            injectScriptTag({
                doc: document,
                id: 'apple-id-auth',
                src:
                    'https://appleid.cdn-apple.com/appleauth/static/jsapi/appleid/1/en_US/appleid.auth.js',
                asyncStrategy,
                onLoad: this.appleInit,
            });
        }
    }

    /* istanbul ignore next */
    appleInit = () => {
        const { clientId, scope, redirectURI } = this.props;

        if (this.areParametersValid()) {
            window?.AppleID?.auth?.init?.({
                clientId,
                scope,
                redirectURI,
                usePopup: true,
            });
        }
    };

    handleOnClick = () => {
        const {
            onClick,
            onSocialConnectVerified,
            onSocialConnectNotAuthorized,
        } = this.props;

        onClick?.(SOCIAL_EXTERNAL_IDENTITY_PROVIDER_APPLE);

        window?.AppleID?.auth
            ?.signIn?.()
            .then((response) => {
                const parsedResponse = buildAppleLoginResponse(response);

                onSocialConnectVerified?.(
                    SOCIAL_EXTERNAL_IDENTITY_PROVIDER_APPLE,
                    parsedResponse,
                );
            })
            .catch((status) => {
                /**
                 * error: The returned error code. (currently only: `user_cancelled_authorize`)
                 * state: The state passed by the init function.
                 *  {
                         "error": "[ERROR_CODE]"
                    }
                    */
                onSocialConnectNotAuthorized?.(
                    SOCIAL_EXTERNAL_IDENTITY_PROVIDER_APPLE,
                    {
                        sourceProvider: SOCIAL_EXTERNAL_IDENTITY_PROVIDER_APPLE,
                        status,
                    },
                );
            });
    };

    areParametersValid = () => {
        const { clientId, redirectURI } = this.props;

        return clientId && redirectURI;
    };

    render() {
        const { buttonAppleText } = this.props;
        const buttonText =
            buttonAppleText || lazyGettext('Continue with Apple');

        return (
            <div className="apple-login__container">
                <Button
                    type="button"
                    size={SIZE_BLOCK}
                    onClick={this.handleOnClick}
                    disabled={!this.areParametersValid()}
                    style={STYLE_LINK}
                >
                    <div className="apple-login__icon">
                        <Icon type={<LogoApple />} size="small" />
                    </div>
                    <div className="apple-login__text">{buttonText}</div>
                </Button>
            </div>
        );
    }
}
